import { createTheme } from '@mui/material/styles';


export const myTheme = createTheme({
    palette: {
      mode: 'dark',
    },
  });